// extracted by mini-css-extract-plugin
export default {"label":"AddDocumentation_label__wXopK","label2":"AddDocumentation_label2__jbHFl","note":"AddDocumentation_note__qlgng"};